import React from "react";
import "./FCYearNav.scss";

type FCYearNavProps = {
    year: number;
    onChange: (year: number) => void;
};

/**
 * Navigation année standardisée (chevron_left / année / chevron_right).
 * Utilise le style "Financial Atelier" commun à Calendar, Statistic, Declaration, etc.
 */
const FCYearNav: React.FunctionComponent<FCYearNavProps> = ({year, onChange}) => {
    return (
        <div className="fcYearNav">
            <button className="fcYearNavBtn" onClick={() => onChange(year - 1)} aria-label="Année précédente">
                <span className="material-symbols-outlined">chevron_left</span>
            </button>
            <span className="fcYearNavValue">{year}</span>
            <button className="fcYearNavBtn" onClick={() => onChange(year + 1)} aria-label="Année suivante">
                <span className="material-symbols-outlined">chevron_right</span>
            </button>
        </div>
    );
};

export default FCYearNav;
